// ShiftHoverMenu.jsx
import React, { useState, useRef } from 'react';
import { shiftType, normalizeShiftType } from "services/shiftsService";
import { FiPlus, FiTrash2 } from 'react-icons/fi';
import { RiPencilFill } from "react-icons/ri";
import { Overlay, Popover } from "react-bootstrap";
import ShiftSelector from 'components/Shifts/ShiftSelector';
import { useTranslation } from 'react-i18next';
import { useShiftHoverMenuPosition } from "hooks/useShiftHoverMenuPosition";

const PlanShiftHoverMenu = ({
	plan,
	defaultShiftId,
	onAdd,
	onShiftAssigned,
	onEdit,
	onDelete,
	showAdd = true,
	showEdit = true,
}) => {
	const { t } = useTranslation();

	const { shift_plan } = plan;
	const normalizedShiftType = shift_plan?.shift?.type
		? normalizeShiftType(shift_plan.shift.type)
		: "";
	const isWorkLikeShift =
		normalizedShiftType === shiftType.work ||
		normalizedShiftType === shiftType.automatic;
	const isAbsenceLikeShift =
		normalizedShiftType === shiftType.absence ||
		normalizedShiftType === shiftType.vacation;
	const isEdit =
		shift_plan &&
		shift_plan.shift &&
		(isWorkLikeShift ||
			isAbsenceLikeShift ||
			shift_plan.shift.allow_hourly_absence_request);

	const [show, setShow] = useState(false);
	const addButtonRef = useRef(null);
	const { containerRef, positionStyle } = useShiftHoverMenuPosition();

	const handleClose = () => setShow(false);
	const handleToggle = () => setShow(!show);

	// onMouseEnter/onMouseLeave para mantenerlo abierto
	// mientras el cursor esté sobre el popover
	const popover = (
		<Popover
			className="shift-selector-popover"
			onMouseEnter={() => setShow(true)}
			onMouseLeave={() => setShow(false)}
		>
			<Popover.Header as="h3">{t('plan.modal.newShift')}</Popover.Header>
			<Popover.Body>
				<ShiftSelector
					plan={plan}
					defaultShiftId={defaultShiftId}
					handleClose={handleClose}
					onAdd={onAdd}
					onShiftAssigned={onShiftAssigned}
				/>
			</Popover.Body>
		</Popover>
	);


	const showDeleteButton = typeof onDelete === "function";
	const containerClass = !showAdd && !showEdit
		? " shift-hover-menu-container--delete-only"
		: !showAdd || !showEdit
			? " shift-hover-menu-container--compact"
			: "";

	return (
		<div
			ref={containerRef}
			className={`shift-hover-menu-container shift-hover-menu-container--fixed${containerClass}`}
			style={positionStyle}
		>
			<div className="shift-hover-menu">
				{showAdd && (
					<>
						<button
							ref={addButtonRef}
							className="btn-hover-action btn-add"
							onClick={(e) => {
								e.stopPropagation();
								handleToggle();
							}}
							title={t('plan.modal.newShift')}
						>
							<FiPlus />
						</button>

						<Overlay
							target={addButtonRef.current}
							show={show}
							placement="bottom"
							containerPadding={10}
							onHide={handleClose}
						>
							{popover}
						</Overlay>
					</>
				)}

				{showEdit && isEdit && typeof onEdit === "function" && (
					<button
						className="btn-hover-action btn-edit"
						onClick={(e) => {
							e.stopPropagation();
							onEdit(plan);
						}}
						title={t('shifts.editShift')}
					>
						<RiPencilFill />
					</button>
				)}
				{showDeleteButton && (
					<button
						className="btn-hover-action btn-delete"
						onClick={(e) => {
							e.stopPropagation();
							onDelete(plan);
						}}
						title={t('plan.removeShift')}
					>
						<FiTrash2 />
					</button>
				)}
			</div>
		</div>
	);
};

export default PlanShiftHoverMenu;

